export const ItemType = {
  PREV: `prev`,
  NEXT: `next`
};
